"use strict";

var _toConsumableArray = require("/codebuild/output/src1330877900/src/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _slicedToArray = require("/codebuild/output/src1330877900/src/node_modules/@babel/runtime/helpers/slicedToArray.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.to-string.js");
var _react = _interopRequireWildcard(require("react"));
var _stateSVGPaths = _interopRequireDefault(require("./stateSVGPaths"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var USMap = function USMap(props) {
  var _props$options, _props$options2, _props$options3, _props$options4, _data$allSitePage;
  var _props$searchPath = props.searchPath,
    searchPath = _props$searchPath === void 0 ? "/search/" : _props$searchPath; // Variables

  var fill = ((_props$options = props.options) === null || _props$options === void 0 ? void 0 : _props$options.fill) || '#DB2C55';
  var onHoverFill = ((_props$options2 = props.options) === null || _props$options2 === void 0 ? void 0 : _props$options2.onHoverFill) || '#BD3051';
  var disabledFill = ((_props$options3 = props.options) === null || _props$options3 === void 0 ? void 0 : _props$options3.disabledFill) || '#6B8398';
  var transition = ((_props$options4 = props.options) === null || _props$options4 === void 0 ? void 0 : _props$options4.transition) || 'all .1s';
  var stateStyle = {
    fill: fill,
    transition: transition,
    cursor: 'default'
  };
  var stateOnHoverStyle = {
    fill: onHoverFill,
    transition: transition,
    cursor: 'pointer'
  };
  var stateDisabledStyle = {
    fill: disabledFill,
    transition: transition,
    cursor: 'default'
  }; // States

  var _ref = (0, _react.useState)(_stateSVGPaths.default),
    _ref2 = _slicedToArray(_ref, 2),
    states = _ref2[0],
    setStates = _ref2[1];
  var _ref3 = (0, _react.useState)(10),
    _ref4 = _slicedToArray(_ref3, 2),
    popupBoxX = _ref4[0],
    setPopupBoxX = _ref4[1];
  var _ref5 = (0, _react.useState)(20),
    _ref6 = _slicedToArray(_ref5, 2),
    popupBoxY = _ref6[0],
    setPopupBoxY = _ref6[1];
  var _ref7 = (0, _react.useState)(false),
    _ref8 = _slicedToArray(_ref7, 2),
    showPopupBox = _ref8[0],
    setShowPopupBoxShow = _ref8[1];
  var _ref9 = (0, _react.useState)(0),
    _ref10 = _slicedToArray(_ref9, 2),
    numberOfPositions = _ref10[0],
    setNumberOfPositions = _ref10[1];
  var _ref11 = (0, _react.useState)(''),
    _ref12 = _slicedToArray(_ref11, 2),
    stateName = _ref12[0],
    setStateName = _ref12[1]; // Parse job data from gql query. Remove any pages that aren't generated on build, ex: /index /search ...

  var data = props.data;
  var jobs = [];
  var allPages = data === null || data === void 0 ? void 0 : (_data$allSitePage = data.allSitePage) === null || _data$allSitePage === void 0 ? void 0 : _data$allSitePage.edges;
  for (var job in allPages) {
    var _allPages$job, _allPages$job$node;
    if ((_allPages$job = allPages[job]) !== null && _allPages$job !== void 0 && (_allPages$job$node = _allPages$job.node) !== null && _allPages$job$node !== void 0 && _allPages$job$node.pageContext) {
      var _allPages$job2, _allPages$job2$node, _allPages$job2$node$p;
      if ((_allPages$job2 = allPages[job]) !== null && _allPages$job2 !== void 0 && (_allPages$job2$node = _allPages$job2.node) !== null && _allPages$job2$node !== void 0 && (_allPages$job2$node$p = _allPages$job2$node.pageContext) !== null && _allPages$job2$node$p !== void 0 && _allPages$job2$node$p.title) {
        var _allPages$job3, _allPages$job3$node;
        jobs.push((_allPages$job3 = allPages[job]) === null || _allPages$job3 === void 0 ? void 0 : (_allPages$job3$node = _allPages$job3.node) === null || _allPages$job3$node === void 0 ? void 0 : _allPages$job3$node.pageContext);
      }
    }
  } // useEffects

  (0, _react.useEffect)(function () {
    var tmpStates = _toConsumableArray(states);
    if (tmpStates && jobs) {
      jobs.forEach(function (job) {
        var jobState = String(job === null || job === void 0 ? void 0 : job.state);
        if (jobState) {
          for (var state in tmpStates) {
            var mapState = tmpStates[state].state;
            if (jobState === mapState) {
              var _tmpStates$state;
              (_tmpStates$state = tmpStates[state]) !== null && _tmpStates$state !== void 0 && _tmpStates$state.count ? tmpStates[state].count++ : tmpStates[state].count = 1;
            }
          }
        }
      });
    }
    setStates(tmpStates); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Handlers

  var onMouseOverHandler = function onMouseOverHandler(e) {
    if (e.target.getAttribute('disabled') !== null) return;
    var name = e.target.getAttribute('name');
    var state = e.target.getAttribute('state');
    if (name) {
      setStateName(name);
    } else if (state) {
      setStateName(state);
    }
    var count = e.target.getAttribute('count');
    if (count) {
      setNumberOfPositions(count);
    }
    var x = e.target.getAttribute('x-value');
    var y = e.target.getAttribute('y-value');
    if (x && y) {
      setPopupBoxX(x);
      setPopupBoxY(y);
    }
    setShowPopupBoxShow(true);
    setStyle(stateOnHoverStyle, e);
  };
  var onMouseOutHandler = function onMouseOutHandler(e) {
    if (e.target.getAttribute('disabled') !== null) return;
    setShowPopupBoxShow(false);
    setPopupBoxX(0);
    setPopupBoxY(0);
    setStyle(stateStyle, e);
  }; // Functions

  var setStyle = function setStyle(styles, e) {
    for (var _i = 0, _Object$keys = Object.keys(styles); _i < _Object$keys.length; _i++) {
      var prop = _Object$keys[_i];
      e.target.style[prop.toString()] = styles[prop.toString()];
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("svg", {
    width: "100%",
    className: {
      width: '100%'
    },
    height: "577px",
    viewBox: "0 0 936 577",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    onMouseOver: onMouseOverHandler,
    onMouseOut: onMouseOutHandler
  }, states.map(function (stateElement) {
    if (!(stateElement !== null && stateElement !== void 0 && stateElement.element)) {
      return /*#__PURE__*/_react.default.createElement("a", {
        href: stateElement !== null && stateElement !== void 0 && stateElement.count ? "".concat(searchPath, "?state=").concat(stateElement.state) : false,
        target: '_blank',
        rel: 'noreferrer'
      }, /*#__PURE__*/_react.default.createElement("path", {
        "x-value": stateElement === null || stateElement === void 0 ? void 0 : stateElement.x,
        "y-value": stateElement === null || stateElement === void 0 ? void 0 : stateElement.y,
        name: stateElement === null || stateElement === void 0 ? void 0 : stateElement.name,
        count: stateElement === null || stateElement === void 0 ? void 0 : stateElement.count,
        disabled: !(stateElement !== null && stateElement !== void 0 && stateElement.count),
        transform: stateElement !== null && stateElement !== void 0 && stateElement.transform ? stateElement.transform : '',
        state: stateElement.state,
        className: 'state',
        style: stateElement !== null && stateElement !== void 0 && stateElement.count ? stateStyle : stateDisabledStyle,
        d: stateElement.d
      }));
    } else {
      if ((stateElement === null || stateElement === void 0 ? void 0 : stateElement.element.toLowerCase()) === 'polygon') {
        return /*#__PURE__*/_react.default.createElement("a", {
          href: stateElement !== null && stateElement !== void 0 && stateElement.count ? "".concat(searchPath, "?state=").concat(stateElement.state) : false,
          target: '_blank',
          rel: 'noreferrer'
        }, /*#__PURE__*/_react.default.createElement("polygon", {
          "x-value": stateElement === null || stateElement === void 0 ? void 0 : stateElement.x,
          "y-value": stateElement === null || stateElement === void 0 ? void 0 : stateElement.y,
          name: stateElement === null || stateElement === void 0 ? void 0 : stateElement.name,
          count: stateElement === null || stateElement === void 0 ? void 0 : stateElement.count,
          disabled: !(stateElement !== null && stateElement !== void 0 && stateElement.count),
          state: stateElement.state,
          className: 'state',
          style: stateElement !== null && stateElement !== void 0 && stateElement.count ? stateStyle : stateDisabledStyle,
          points: stateElement.points
        }));
      }
    }
    return null;
  }), /*#__PURE__*/_react.default.createElement("foreignObject", {
    style: {
      pointerEvents: 'none',
      display: showPopupBox ? '' : 'none'
    },
    x: popupBoxX,
    y: popupBoxY,
    height: 200,
    width: 400
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: 12,
      whiteSpace: 'nowrap',
      minWidth: 150,
      width: 'min-content'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      background: '#ffffff',
      borderRadius: '5px',
      minHeight: 50,
      padding: '2px 20px',
      boxShadow: '0 0 8px 3px rgba(0,0,0,.2),0 8px 16px -8px rgba(0,0,0,.3)',
      color: '#000000'
    }
  }, /*#__PURE__*/_react.default.createElement("p", {
    style: {
      fontWeight: 'bold',
      fontSize: 20
    }
  }, stateName), /*#__PURE__*/_react.default.createElement("p", null, numberOfPositions, ' ', numberOfPositions > 1 ? 'Openings' : 'Opening')))))));
};
var _default = USMap;
exports.default = _default;